export default __webpack_public_path__ + "static/media/sapota.43e332db.png";